import { render, staticRenderFns } from "./LProjectObjectPreview.vue?vue&type=template&id=45abb857&scoped=true&"
import script from "./LProjectObjectPreview.vue?vue&type=script&lang=js&"
export * from "./LProjectObjectPreview.vue?vue&type=script&lang=js&"
import style0 from "./LProjectObjectPreview.vue?vue&type=style&index=0&id=45abb857&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abb857",
  null
  
)

export default component.exports